import { alpha } from '@mui/material';
import MuiDrawer from '@mui/material/Drawer';
import { CSSObject, styled, Theme } from '@mui/material/styles';

const openedMixin = (theme: Theme): CSSObject => ({
  width: theme.custom.drawerWidth as string,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  borderRight: 'none',
});

const closedMixin = (theme: Theme): CSSObject => ({
  width: theme.custom.drawerWidthClosed as string,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  borderRight: 'none',
});

export const getListItemStyles = (theme: Theme, drawerExpanded: boolean) => {
  return {
    justifyContent: drawerExpanded ? 'flex-start' : 'center',
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: '10px',
    height: '48px',
    padding: 0,
    backgroundColor: 'transparent',
    transition: theme.transitions.create('all', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.shorter,
    }),
    width: drawerExpanded ? '240px' : '64px',
    pl: '1px',
    pr: drawerExpanded ? '20px' : '0px',
    color: theme.palette.text.secondary,
    fontWeight: '400 !important',
    fontSize: '1.125rem !important',
    '&:hover': {
      backgroundColor: theme.palette.charts.social[1] as string,
      fontWeight: '500 !important',
    },
    '&.Mui-selected': {
      fontWeight: '500 !important',
      backgroundColor: alpha(theme.palette.primary.main, 0.2),
      color: theme.palette.primary.main,
      '& .MuiSvgIcon-root': { color: theme.palette.primary.main },
    },
  };
};

export const getToggleButtonStyles = (theme: Theme, drawerExpanded: boolean) => {
  return {
    position: 'fixed',
    border: '2.5px solid',
    borderColor: 'text.secondary',
    width: theme.spacing(4),
    height: theme.spacing(4),
    borderRadius: theme.spacing(4),
    top: '80px',
    left: drawerExpanded
      ? (theme.custom.drawerWidth as string)
      : (theme.custom.drawerWidthClosed as string),
    transition: theme.transitions.create('all', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: theme.palette.charts.social[1] as string,
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    transform: `translateX(-50%) rotate(${drawerExpanded ? '0' : '180'}deg)`,
  };
};

export const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    zIndex: 10,
    width: theme.custom.drawerWidth as string,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  })
);
